import {
  Spin,
  Steps,
  Select,
  List,
  Avatar,
  Alert,
  Tooltip,
  Button,
  Popconfirm,
  Input,
  Modal,
  Tag,
} from "antd";
import { useMutation, useQuery } from "react-query";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../config/axios-instance";
import { LoadingOutlined } from "@ant-design/icons";
import avatar_placeholder from "../../img/avatar_placeholder.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import proto_illustration from "../../img/Prototype.svg";
import backArrow from "../../img/backArrow.png";
import { history } from "../..";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DatabaseOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import moment from "moment";
import { CancelOrderDrawer } from "../MyOrderConfirmation/CancelOrderDrawer";
import { MyNotif } from "../NotifIcons/NotifIcons";
import {
  approveCustomizedProductAndComment,
  rejectOrAcceptProtoCustomized,
} from "../../actions/order-actions/actions";
const { Step } = Steps;
const { Option } = Select;

const CustomizedProgress = () => {
  const params = useParams<any>();
  const [isOpened, setIsOpened] = useState(false);
  function edit() {
    setIsOpened((wasOpened) => !wasOpened);
  }
  const routerHistory = useHistory();

  const [proto, setProto] = useState("");
  const [startDate, setStartDate] = useState("");
  const [shippingDate, setShippingDate] = useState("");
  const [datetirmswearhouse, setTirmswearhouse] = useState("");
  const [datefabricwearhouse, setFabricwearhouse] = useState("");
  const [qty, setQty] = useState("");
  const [size_qty, setSizeQty] = useState("");
  const [deliverydate, setDeliveryDate] = useState("");
  const [comment, setComment] = useState("");
  const [selectdStep, setSelectdStep] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  function handleChangeDateTirmswearhouse(e: any) {
    setTirmswearhouse(e.target.value);
  }

  function handleChangeDateFabricwearhouse(e: any) {
    setFabricwearhouse(e.target.value);
  }
  function handleChangeDeliveryDate(e: any) {
    setDeliveryDate(e.target.value);
  }

  function handleChangeProto(e: any) {
    setProto(e.target.value);
  }

  function handleChangeStartDate(e: any) {
    setStartDate(e.target.value);
  }
  function handleChangeShippingDate(e: any) {
    setShippingDate(e.target.value);
  }
  const showCancelDrawer = () => {
    setIsVisible(true);
  };
  const {
    mutateAsync: approveOptAndComment,
    isLoading: approvingAndCommentLoading,
  } = useMutation(approveCustomizedProductAndComment);

  const {
    mutateAsync: rejectOrAcceptProto,
    isLoading: rejectOrAcceptProtoLoading,
  } = useMutation(rejectOrAcceptProtoCustomized, {
    onSuccess: (res) => {
      MyNotif(`Product ${res}ed and comments added successfully`, "success");
      window.location.reload();
    },
  });
  const valider = async (status: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/custom_products/admin/${params.product_id}`,
      data: {
        status_id: status,
        proto: proto,
        start_production_date: startDate,
        shipping_date: shippingDate,
        qty: qty,
        size_qty: size_qty,
        delivery_date: deliverydate,
        date_trims_wearhouse: datetirmswearhouse,
        date_fabric_wearhouse: datefabricwearhouse,
        comment: "Approved: " + comment,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();

    return "ok";
  };

  const next = async (status: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/custom_products/next/${params.product_id}`,
      data: {
        status_id: status,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();
    return "ok";
  };

  const approve = async (id: any, status_id: any, product_id: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "post",
      url: `/custom_products/addCommentApprove/${params.order_id}`,
      data: {
        client_id: id,
        status_id: status_id,
        product_id: product_id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    /*     if (status_id !== 5) {
      const { data: reponse2 } = await axiosInstance({
        method: "put",
        url: `/custom_products/next/${params.product_id}`,
        data: {
          status_id: status_id + 1,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } */
    window.location.reload();
    return "ok";
  };

  const fetchCustomized = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/customized_products/${params.product_id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  const { isLoading, data } = useQuery(
    "customized_product",
    () => fetchCustomized(),
    {
      keepPreviousData: true,
    }
  );
  const [step, setSetp] = useState(data?.data?.status?.id);

  const downloadZipFileFromLaravel = (type: any) => {
    axiosInstance({
      url: `/download-files/${params.product_id}`,
      method: "GET",

      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "files.zip"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  const notApprovedOption = async (feedback: string = "") => {
    console.log(`Product ${data?.data.name} is not approved!!`);
    var product_id = data?.data.id;
    if (!feedback) {
      await approveOptAndComment({
        product_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
      });
    } else {
      await approveOptAndComment({
        product_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
        feedback,
      });
    }
    await rejectOrAcceptProto({
      response: "reject",
      id: +product_id,
      comment: `Not Approved: ${comment}`,
    });

    setIsVisible(false);
    setComment("");
    setTimeout(() => {}, 2000);
  };

  const onChange = (value: any) => {
    console.log(`selected ${value}`);
    setSelectdStep(value);
    showConfirm(value);
  };

  const { confirm } = Modal;

  function showConfirm(value: any) {
    confirm({
      title: "You are moving to the selected step, Proceed... ?",

      onOk() {
        /*    approve(
          data?.data?.client?.id,
          data?.data?.status?.id,
          data?.data?.product_id
        ); */
        next(value);
      },
      onCancel() {
        console.log("Cancel");
        setSelectdStep("1");
      },
    });
  }

  const onSearch = (value: any) => {
    console.log("search:", value);
  };
  const stepName = ["PROTO", "PRE SMS", "SMS", "OK PROD", "PRODUCTION"];

  return isLoading ? (
    <div
      style={{ width: "100%", height: "100%" }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    data && (
      <div className="row myorder_confirmation" style={{ minHeight: "100vh" }}>
        <div
          className="col-12 col-md-5 p-0 d-flex align-items-center"
          style={{ background: "#fcfdff", height: "100%" }}
        >
          {/* <img
            src={
              data.data.proto
                ? process.env.REACT_APP_STORAGE_URL + data.data.proto
                : proto_illustration
            }
            alt="prototype"
            className="proto_img img-fluid"
            style={{
              objectFit: data.data && data.data.proto ? "contain" : "cover",
            }}
          /> */}

          {/*   <iframe
            src={
              data.data.proto
                ? process.env.REACT_APP_STORAGE_URL + data.data.proto
                : proto_illustration
            }
            style={{
              width: "100%",
              height: "calc(100vh - 227px)",
              border: "none",
            }}
          /> */}
          <iframe
            src={
              data.data.proto
                ? data.data.proto
                : data.data.original_product.link_360
            }
            style={{
              width: "100%",
              height: "calc(100vh - 227px)",
              border: "none",
            }}
          />
        </div>
        <div className="col-12 col-md-7 proto_container pl-3">
          <div
            className=" m-4"
            style={{
              justifyContent: "space-between",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="proto_header">
              <img
                src={backArrow}
                className="back_arrow_folder"
                alt="back arrow"
                onClick={() => history.back()}
              />
              <h1>Orders</h1>
            </div>

            <div>
              {data.data.status?.id != 6 && (
                <div>
                  <Tooltip
                    placement="bottom"
                    title={isOpened == false ? "Update" : "View"}
                  >
                    <Button
                      type="ghost"
                      shape="circle"
                      size="large"
                      className="update_product_btn"
                      icon={
                        isOpened == false ? (
                          <EditOutlined />
                        ) : (
                          <EyeOutlined></EyeOutlined>
                        )
                      }
                      onClick={edit}
                    />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          <div className="proto_breadcrumb_container my-4">
            <p className="proto_breadcrumb">{`${data.data.client.name}/${data.data.name}`}</p>
          </div>
          <div className="steps_progress mt-4">
            {data.data.status.id !== 6 ? (
              <Steps
                current={data.data.status.id - 1}
                labelPlacement={"vertical"}
              >
                <Step
                  title="PROTO"
                  onClick={() => setSetp(1)}
                  description={
                    data.data.status.id >= 1 && isOpened == false
                      ? "View details"
                      : ""
                  }
                  style={{
                    cursor:
                      data.data.status.id >= 1 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                />
                <Step
                  title="PRE SMS"
                  onClick={() => setSetp(2)}
                  style={{
                    cursor:
                      data.data.status.id >= 2 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    data.data.status.id >= 2 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="SMS"
                  onClick={() => setSetp(3)}
                  style={{
                    cursor:
                      data.data.status.id >= 3 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    data.data.status.id >= 3 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="OK PROD"
                  onClick={() => setSetp(4)}
                  style={{
                    cursor:
                      data.data.status.id >= 4 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    data.data.status.id >= 4 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="PRODUCTION"
                  onClick={() => setSetp(5)}
                  style={{
                    cursor:
                      data.data.status.id >= 5 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    data.data.status.id >= 5 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
              </Steps>
            ) : (
              /*   <Alert
                message="This order was cancelled"
                type="error"
                showIcon
                className="ml-3 w-75 rounded"
              /> */
              <></>
            )}
          </div>
          <div>
            {" "}
            {data?.data?.orders_status.map((el: any) => {
              console.log(data?.data?.status?.id - 1);
              return (
                <>
                  {el.proto_confirmation === "ACCEPTED" &&
                    el.status_id == data?.data?.status?.id && (
                      <div className="col-2">
                        <Tag
                          icon={<CheckOutlined />}
                          style={{
                            borderRadius: "15px",
                            padding: "5px 9px 5px 9px",
                          }}
                          color="#00468c"
                        >
                          Approved
                        </Tag>
                      </div>
                    )}
                </>
              );
            })}
          </div>

          {isOpened == false ? (
            <>
              {" "}
              <div className="proto_footer mt-5">
                <table
                  className="table_production "
                  style={{
                    marginBottom: "25px",
                    borderRadius: "1em",
                  }}
                >
                  {data?.data?.orders_status.map((el: any) => {
                    {
                      return (
                        <>
                          {el.status_id == step ? (
                            <>
                              <table
                                className="table_production "
                                style={{
                                  marginBottom: "25px",
                                  borderRadius: "1em",
                                }}
                              >
                                <tr className="border">
                                  <th
                                    className="border-right p-3"
                                    style={{ width: "300px" }}
                                  >
                                    Download File
                                  </th>
                                  <td
                                    className="p-3"
                                    style={{ width: "300px" }}
                                  >
                                    <a
                                      onClick={() =>
                                        downloadZipFileFromLaravel(1)
                                      }
                                      href={
                                        process.env.REACT_APP_API_URL +
                                        `/download-files/${params.product_id}`
                                      }
                                      style={{ color: "#00468C" }}
                                    >
                                      Download
                                    </a>
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">Qty</th>
                                  <td className="p-3">{el.qty || "-"}</td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">size qty</th>
                                  <td className="p-3">{el.size_qty || "-"}</td>
                                </tr>
                                {/*    <tr className="border">
                                  <th className="border-right p-3">
                                    Date trims wearhouse
                                  </th>
                                  <td className="p-3">
                                    {el.date_trims_wearhouse
                                      ? moment(el.date_trims_wearhouse).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Date fabric wearhouse
                                  </th>
                                  <td className="p-3">
                                    {el.date_fabric_wearhouse
                                      ? moment(el.date_fabric_wearhouse).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr> */}
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Start production date
                                  </th>
                                  <td className="p-3">
                                    {el.start_production_date
                                      ? moment(el.start_production_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Shipping date
                                  </th>
                                  <td className="p-3">
                                    {el.shipping_date
                                      ? moment(el.shipping_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Delivery date
                                  </th>
                                  <td className="p-3">
                                    {el.delivery_date
                                      ? moment(el.delivery_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                              </table>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    }
                  })}
                  {/*    <tr className="border">
                    <th className="border-right p-3" style={{ width: "300px" }}>
                      Download File
                    </th>
                    <td className="p-3" style={{ width: "300px" }}>
                      <a
                        onClick={() => downloadZipFileFromLaravel(1)}
                        style={{ color: "#00468C" }}
                      >
                        Download
                      </a>
                    </td>
                  </tr>
                  <tr className="border">
                    <th className="border-right p-3">Quantity</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {data.data.qty}
                    </td>
                  </tr>
                  <tr className="border">
                    <th className="border-right p-3">Start Production</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {data.data.start_production_date
                        ? moment(data.data?.start_production_date).format(
                            "YYYY-MM-DD"
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr className="border">
                    <th className="border-right p-3">Shipping Date</th>
                    <td className="p-3" style={{ width: 200 }}>
                      {data.data.shipping_date
                        ? moment(data.data.shipping_date).format("YYYY-MM-DD")
                        : "-"}
                    </td>
                  </tr> */}
                </table>
                {/*   {data.data?.status?.id == 5 && (
                  <table className="table_production bg-white">
                    <tr className="border">
                      <th className="border-right p-3">Quantity</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {data.data.qty}
                      </td>
                    </tr>
                    <tr className="border">
                      <th className="border-right p-3">Start Production</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {data.data.start_production_date
                          ? moment(data.data?.start_production_date).format(
                              "YYYY-MM-DD"
                            )
                          : ""}
                      </td>
                    </tr>
                    <tr className="border">
                      <th className="border-right p-3">Shipping Date</th>
                      <td className="p-3" style={{ width: 200 }}>
                        {data.data.shipping_date
                          ? moment(data.data.shipping_date).format("YYYY-MM-DD")
                          : ""}
                      </td>
                    </tr>
                  </table>
                )} */}
              </div>
            </>
          ) : (
            <>
              <>
                <div className="proto_footer_btns my-4">
                  <Button
                    type="default"
                    className="cancel_btn"
                    style={{ height: "40px" }}
                    onClick={() => showCancelDrawer()}
                  >
                    Cancel
                  </Button>
                  {/*    {data.data.status?.comments?.length > 0 ? (
                    <></>
                  ) : ( */}
                  <>
                    {data.data.status?.id !== 5 ? (
                      <div style={{ marginLeft: "25px" }}>
                        <Select
                          showSearch
                          placeholder="Select Step"
                          optionFilterProp="children"
                          // onChange={onChange}
                          onSearch={onSearch}
                          onSelect={onChange}
                          size={"large"}
                          filterOption={(input, option) =>
                            (option!.children as unknown as string)
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: 150, borderRadius: "5px" }}
                          defaultValue={data.data.status?.name}
                        >
                          <Option
                            value="1"
                            disabled={data.data.status?.id >= 1}
                          >
                            PROTO
                          </Option>
                          <Option
                            value="2"
                            disabled={data.data.status?.id >= 2}
                          >
                            PRE SMS
                          </Option>
                          <Option
                            value="3"
                            disabled={data.data.status?.id >= 3}
                          >
                            SMS
                          </Option>
                          <Option
                            value="4"
                            disabled={data.data.status?.id >= 4}
                          >
                            OK PROD
                          </Option>
                          <Option
                            value="5"
                            disabled={data.data.status?.id >= 5}
                          >
                            PRODUCTION
                          </Option>
                        </Select>{" "}
                      </div>
                    ) : (
                      <>
                        <Button
                          type="default"
                          className="approve_btn"
                          onClick={() =>
                            approve(
                              data?.data?.client?.id,
                              data?.data?.status?.id,
                              data?.data?.product_id
                            )
                          }
                          disabled={data.data.status?.comments?.length > 0}
                        >
                          Approve
                        </Button>
                      </>
                    )}
                  </>
                  {/*      )} */}
                </div>
              </>
              <div className="proto_breadcrumb_container">
                {data.data.orders_status.map((el: any) => {
                  {
                    return (
                      <>
                        {el.status_id == data.data.status?.id ? (
                          <div>
                            <div>
                              <div className="mb-4">
                                {data.data.status?.id != 5 && (
                                  <>
                                    <label className="mr-3 mb-0"> Proto</label>
                                    <Input
                                      type="text"
                                      defaultValue={el.proto}
                                      onChange={handleChangeProto}
                                      style={{
                                        borderRadius: "5px",
                                      }}
                                    ></Input>
                                  </>
                                )}
                                {(data.data.status?.id == 5 ||
                                  data.data.status?.id == 4 ||
                                  data.data.status?.id == 3 ||
                                  data.data.status?.id == 2 ||
                                  data.data.status?.id == 1) && (
                                  <>
                                    <label className="mr-3 mb-0">
                                      {" "}
                                      Quantity{" "}
                                    </label>

                                    <Input
                                      type="text"
                                      defaultValue={qty || el.qty}
                                      style={{
                                        borderRadius: "5px",
                                        marginBottom: "15px",
                                      }}
                                      onChange={(e: any) =>
                                        setQty(e.target.value)
                                      }
                                    ></Input>
                                    <label className="mr-3 mb-0">
                                      Size's Quantity{" "}
                                    </label>

                                    <Input
                                      type="text"
                                      style={{
                                        borderRadius: "5px",
                                        marginBottom: "15px",
                                      }}
                                      defaultValue={size_qty || el.size_qty}
                                      placeholder="S:10;M:10"
                                      onChange={(e: any) =>
                                        setSizeQty(e.target.value)
                                      }
                                    ></Input>
                                    <label className="mr-3 mb-0">
                                      Delivery date
                                    </label>
                                    <Input
                                      type="date"
                                      style={{
                                        borderRadius: "5px",
                                        marginBottom: "15px",
                                      }}
                                      value={
                                        deliverydate ||
                                        moment(el.delivery_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      }
                                      onChange={handleChangeDeliveryDate}
                                    ></Input>
                                  </>
                                )}
                                <label className="mr-3 mb-0">
                                  {" "}
                                  Start production date{" "}
                                </label>
                                <Input
                                  type="date"
                                  value={
                                    startDate ||
                                    moment(el.start_production_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  }
                                  onChange={handleChangeStartDate}
                                  style={{
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                  }}
                                ></Input>
                                <label className="mr-3 mb-0">
                                  {" "}
                                  Shipping date{" "}
                                </label>
                                <Input
                                  type="date"
                                  value={
                                    shippingDate ||
                                    moment(el.shipping_date).format(
                                      "YYYY-MM-DD"
                                    )
                                  }
                                  onChange={handleChangeShippingDate}
                                  style={{
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                  }}
                                ></Input>

                                {/*   <label className="mr-3 mb-0">
                                  {" "}
                                  Date fabric wearhouse{" "}
                                </label>
                                <Input
                                  type="date"
                                  value={
                                    datefabricwearhouse ||
                                    moment(el.date_fabric_wearhouse).format(
                                      "YYYY-MM-DD"
                                    )
                                  }
                                  onChange={handleChangeDateFabricwearhouse}
                                  style={{
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                  }}
                                ></Input> */}

                                {/*    <label className="mr-3 mb-0">
                                  {" "}
                                  Date trims wearhouse{" "}
                                </label>
                                <Input
                                  type="date"
                                  value={
                                    datetirmswearhouse ||
                                    moment(el.date_trims_wearhouse).format(
                                      "YYYY-MM-DD"
                                    )
                                  }
                                  onChange={handleChangeDateTirmswearhouse}
                                  style={{
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                  }}
                                ></Input> */}
                              </div>

                              {isOpened == true && (
                                <div>
                                  <textarea
                                    rows={4}
                                    name="comment"
                                    placeholder="Add client comment"
                                    className="comment_proto_order my-4"
                                    onChange={(e: any) =>
                                      setComment(e.target.value)
                                    }
                                    disabled={
                                      data.data.status?.comments?.length > 0
                                    }
                                  ></textarea>
                                </div>
                              )}

                              <div className="proto_footer_btns my-4">
                                <Button
                                  type="default"
                                  className="cancel_btn"
                                  onClick={() => valider(data.data.status?.id)}
                                >
                                  Save
                                </Button>

                                {/* {data.data.status?.comments?.length > 0 && (
                                  <Popconfirm
                                    title="Are you sure to move to the next step ?"
                                    onConfirm={() =>
                                      next(data.data.status_id + 1)
                                    }
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Button
                                      type="default"
                                      className="approve_btn"
                                    >
                                      Next
                                    </Button>
                                  </Popconfirm>
                                )} */}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })}
              </div>
            </>
          )}
          {isOpened == false && (
            <>
              {data.data.status.id !== 6 ? (
                <div className="proto_footer">
                  <div className="mt-4">
                    <h1 className="my-3">
                      {data.data.original_product.name}{" "}
                      {data.data.original_product.code}
                    </h1>
                  </div>

                  {data && data?.data?.allComment.length > 0 ? (
                    <>
                      {/*    {data?.data?.allComment?.map((el: any) => {
                        {
                          return (
                         
                          );
                        }
                      })} */}
                      <>
                        <List
                          itemLayout="horizontal"
                          dataSource={data?.data?.allComment}
                          renderItem={(item: any) => (
                            <List.Item>
                              <List.Item.Meta
                                avatar={
                                  <Avatar
                                    src={
                                      data?.data?.client?.logo
                                        ? process.env.REACT_APP_STORAGE_URL +
                                          data?.data.client.logo
                                        : avatar_placeholder
                                    }
                                  />
                                }
                                title={
                                  <a>
                                    <span>{stepName[item.status_id - 1]}</span>
                                    {item.comment.includes("NOT")
                                      ? " NOT APPROVED BY"
                                      : " APPROVED BY"}
                                    {data?.data?.client?.name}
                                  </a>
                                }
                                description={item.comment}
                              />
                            </List.Item>
                          )}
                        />
                      </>
                    </>
                  ) : (
                    <h4 className="text-muted text-center">No comments</h4>
                  )}
                </div>
              ) : (
                <>
                  {" "}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h4
                      className="text-center"
                      style={{ color: "red", fontWeight: 400 }}
                    >
                      This product has been cancelled
                    </h4>
                    <div className="proto_footer_btns my-4">
                      <Button
                        type="default"
                        className="approve_btn"
                        onClick={() =>
                          routerHistory.push(`/all-clients/${params.id}/2`)
                        }
                      >
                        Go back to orders
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <CancelOrderDrawer
          isVisible={isVisible}
          setIsVisible={setIsVisible}
          article={data}
          notApprovedOption={notApprovedOption}
          // setAlerts={setAlerts}
          orderType={"customized_order"}
          productToCancel={data?.data.id}
          approvingAndCommentLoading={approvingAndCommentLoading}
          rejectOrAcceptProtoLoading={rejectOrAcceptProtoLoading}
        />
      </div>
    )
  );
};

export default CustomizedProgress;
